import { gql, useQuery } from "@apollo/client";
import { Clinic } from "../../types";

const ALL_CLINICS_QUERY = gql`
  query allClinics {
    allClinics {
      id
      name
    }
  }
`;

interface AllClinicsResponse {
  allClinics: Clinic[];
}

export function useAllClinics() {
  return useQuery<AllClinicsResponse>(ALL_CLINICS_QUERY);
}
